import EmailIcon from '@mui/icons-material/Email'
import { contact } from '../../portfolio'
import './Contact.css'

const Contact = () => {
  if (!contact.email) return null

  return (
    <section className='section' id='contact'>
      <h2 className='section__title'>Get In Touch</h2>
      <div className='contact center'>
        <p className='contact__description'>
          I'm always open to discussing new opportunities, interesting projects,
          or just having a great conversation about technology and innovation.
        </p>
        <a href={`mailto:${contact.email}`} className='contact__email'>
          <EmailIcon />
          {contact.email}
        </a>
      </div>
    </section>
  )
}

export default Contact
